import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { ActivityLog } from '../generic/ActivityLog';

/** Bereiche des Aufgaben-Protokolls. */
const TASK_LOG_AREAS = [
  { label: 'Aufgabe', entityTypes: ['Task'] },
  { label: 'Zuweisung', entityTypes: ['TaskUser', 'TaskUserGroup'] },
  { label: 'Kommentare', entityTypes: ['TaskComment', 'TaskCommentUser'] },
  { label: 'Dokumente', entityTypes: ['Document', 'Task_has_Document'] },
];

interface IProps {
  isLoading?: boolean;
  /** Ohne Id gibt es nichts anzuzeigen — das Protokoll hängt an ihr. */
  idTask?: number | null;
}

/** Aufgaben-Protokoll (#1248, seit #1330 aus `AuditEvent`).
 *
 * Die Alt-Liste aus `TaskLog` ist entfallen: ihre Einträge stehen seit
 * `20260914_legacy_log_migration.sql` als `Category='legacy'` im zentralen
 * Protokoll und erscheinen dadurch hier mit — mit demselben Satz und
 * demselben Zeitpunkt wie vorher.
 */
export const TaskLogList: React.FC<IProps> = ({
  isLoading = false,
  idTask = null,
}) => {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (!idTask) return null;

  return (
    <ActivityLog
      entityType='Task'
      entityId={idTask}
      areas={TASK_LOG_AREAS}
      rowsPerPage={15}
    />
  );
};
